import MainLayout from '../main-layout';
import NivelatTutorialBox from '../nivelat-tutorial-box';

import useStyles from './TutorialPage.styles';

const TutorialPage = ({ history, title }) => {
  const classes = useStyles();
  return (
    <MainLayout history={history} title={title}>
      <div className={classes.root}>
        <NivelatTutorialBox />
      </div>
    </MainLayout>
  );
};

export default TutorialPage;
